import { isOnScreenLogEnabled, tLog, tWarn, tError } from 'utils/device/tizenLog';

var TAG = 'HTTP';

export function shortUrl(url) {
  if (!url) {
    return '(empty)';
  }
  var prefix = /[?&]apikey=/i.test(url) ? '[apikey] ' : '[bare] ';
  if (url.length <= 64) {
    return prefix + url;
  }
  return prefix + url.slice(0, 64) + '…';
}

export function logHttp(msg) {
  if (!isOnScreenLogEnabled) {
    return;
  }
  tLog(TAG, msg);
}

export function warnHttp(msg) {
  if (!isOnScreenLogEnabled) {
    return;
  }
  tWarn(TAG, msg);
}

export function errorHttp(msg) {
  if (!isOnScreenLogEnabled) {
    return;
  }
  tError(TAG, msg);
}

export function logNativePlayerState(player, label) {
  if (!isOnScreenLogEnabled || typeof player.getPlayerState !== 'function') {
    return;
  }

  var state = player.getPlayerState();
  var avState = 'n/a';
  var playTime = 'n/a';
  var avplay = state.gAVplayObj;

  if (avplay && typeof avplay.getState === 'function') {
    try {
      avState = avplay.getState();
    } catch (e) {
      avState = 'err';
    }
  }
  if (avplay && typeof avplay.getCurrentPlayTime === 'function') {
    try {
      playTime = String(avplay.getCurrentPlayTime());
    } catch (e) {
      playTime = 'err';
    }
  }

  logHttp(
    label +
      ' av=' +
      avState +
      ' playMs=' +
      playTime +
      ' httpMs=' +
      (state.httpPlayTimeMs || 0) +
      ' req=' +
      state.playRequestId
  );
}
